(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/tickets/assets/javascripts/tickets.js') >= 0) return;  svs.modules.push('/templates/tickets/assets/javascripts/tickets.js');
'use strict';

var _svs$tickets;
if ((_svs$tickets = svs.tickets) !== null && _svs$tickets !== void 0 && (_svs$tickets = _svs$tickets.data) !== null && _svs$tickets !== void 0 && _svs$tickets.templateConfig) {
  var _templateConfig$navig;
  const templateConfig = svs.tickets.data.templateConfig;
  let branding = templateConfig.branding;
  if (!templateConfig.hideNav) {
    const clickCallback = e => {
      const event = {
        category: "".concat(branding, "_nav"),
        action: 'click_secondaryMenu',
        opt_label: e.title || ''
      };
      svs.components.analytics.trackEvent(event);
      svs.core.log.getLogger('ui:items-menu').debug('tracking click_secondaryMenu event:', event);
      location.href = e.href;
    };
    const options = {
      el: "js-items-menu-".concat(branding),
      class: "js-items-menu-".concat(branding),
      useScrollHelpers: svs.core.detect.formfactor.desktop(),
      useScrollFaders: true,
      showScrollbar: false,
      scrollToSelected: true,
      clickCallback
    };
    new svs.ui.ItemsMenu(options);
  }
  if ((_templateConfig$navig = templateConfig.navigationBack) !== null && _templateConfig$navig !== void 0 && _templateConfig$navig.enabled) {
    var _svs$tur, _ReactRouterDOM;
    const container = document.getElementById('tickets-navigation-back');
    const NavigationBack = (_svs$tur = svs.tur) === null || _svs$tur === void 0 ? void 0 : _svs$tur.NavigationBack;
    const MemoryRouter = (_ReactRouterDOM = ReactRouterDOM) === null || _ReactRouterDOM === void 0 ? void 0 : _ReactRouterDOM.MemoryRouter;
    const currentPath = templateConfig.navigationBack.currentPath || window.location.pathname;
    const hasReact = typeof React !== 'undefined';
    const hasReactDOM = typeof ReactDOM !== 'undefined';
    if (container && NavigationBack && MemoryRouter && hasReact && hasReactDOM) {
      const approvedPaths = templateConfig.navigationBack.approvedPaths || [];
      const defaultApprovedPath = approvedPaths[0] || currentPath;
      const routes = {
        [currentPath]: {
          text: templateConfig.navigationBack.text,
          navigate: () => svs.utils.url.navigate(defaultApprovedPath)
        }
      };
      approvedPaths.forEach(approvedPath => {
        if (!routes[approvedPath]) {
          routes[approvedPath] = {
            text: templateConfig.navigationBack.text,
            navigate: () => svs.utils.url.navigate(approvedPath)
          };
        }
      });
      ReactDOM.render(React.createElement(MemoryRouter, {
        initialEntries: [currentPath]
      }, React.createElement(NavigationBack, {
        brand: templateConfig.navigationBack.brand,
        routes
      })), container);
    }
  }
  const headerLogo = document.querySelector('.js-top-center-content');
  headerLogo === null || headerLogo === void 0 ? void 0 : headerLogo.addEventListener('click', () => {
    branding = branding === 'fler-lotter-new' ? 'fler lotter' : branding;
    svs.components.analytics.trackEvent({
      category: 'Navigation',
      action: 'logo click',
      opt_label: branding.toUpperCase()
    });
  });
}

 })(window);